import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

const BoxInput: React.FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      bgColor="#F4F5F5"
      color="#6A7171"
      border="1px solid #C0C4C4"
      h="40px"
      px="16px"
      borderRadius="md"
      {...props}
    >
      {children}
    </Box>
  );
};

export default BoxInput;
